import React, { useState } from "react";

const ProductVariantCard = ({ product }) => {
    const [expanded, setExpanded] = useState(true);
    const variants = product.variants || [];

    if (variants.length === 0) return null;

    return (
        <div className="card mb-4">
            <div className="card-header d-flex justify-content-between align-items-center">
                <h5 className="mb-0">VARIANTS</h5>
                <button 
                    className="btn btn-sm btn-outline-secondary"
                    onClick={() => setExpanded(!expanded)}
                >
                    {expanded ? 'Collapse' : 'Expand'}
                </button>
            </div>
            {expanded && (
                <div className="card-body">
                    <div className="table-responsive">
                        <table className="table table-bordered table-hover">
                            <thead className="table-light">
                                <tr>
                                    <th>#</th>
                                    <th>SKU</th>
                                    <th>Stock</th>
                                    <th>Extra Price</th>
                                    <th>Default</th>
                                </tr>
                            </thead>
                            <tbody>
                                {variants.map((variant, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{variant.sku || '-'}</td>
                                        <td>{variant.stock || 0}</td>
                                        <td>₹{parseFloat(variant.extra_price).toLocaleString() || '0'}</td>
                                        <td>
                                            {variant.is_default === 1 ? (
                                                <span className="badge bg-primary">Default</span>
                                            ) : '-'}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProductVariantCard;